var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicWand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_620_138848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.90869 5.02367L8.05931 7.74805L7.239 5.02367L4.51463 4.1743L7.239 3.35398L8.05931 0.599609L8.90869 3.35398L11.6331 4.1743L8.90869 5.02367ZM13.6553 3.5293L13.2446 4.90648L12.7759 3.5293L11.4278 3.08961L12.7759 2.67898L13.2446 1.33086L13.6553 2.67898L15.0034 3.08961L13.6553 3.5293ZM0.265876 18.5002L17.0527 2.21117C17.1699 2.06492 17.3462 1.9768 17.5506 1.9768C17.814 1.94773 18.0784 2.03586 18.2827 2.24023C18.3709 2.2993 18.4881 2.41648 18.6634 2.56273C18.9859 2.85617 19.3374 3.20773 19.6009 3.5593C19.7181 3.73555 19.7771 3.8818 19.7771 4.02805C19.8062 4.32148 19.7181 4.58492 19.5427 4.76023L2.75588 21.1084C2.60963 21.2546 2.43338 21.3137 2.22806 21.3427C1.96463 21.3718 1.70025 21.2837 1.49588 21.0793C1.40775 20.9912 1.29056 20.903 1.11525 20.7277C0.792751 20.4643 0.441189 20.1127 0.206814 19.7312C0.0896262 19.5549 0.0305637 19.3796 0.00150116 19.2334C-0.0275613 18.9399 0.0605637 18.7055 0.264939 18.5012L0.265876 18.5002ZM13.7424 6.6643L14.9734 7.9243L18.8696 4.14523L17.6387 2.85617L13.7424 6.6643ZM5.56931 8.33398L5.18869 9.68211L4.77806 8.33398L3.42994 7.8943L4.77806 7.48367L5.18869 6.10648L5.56931 7.48367L6.97556 7.8943L5.56931 8.33398ZM19.2212 7.3093L19.6609 8.68648L21.009 9.09711L19.6609 9.5368L19.2212 10.8849L18.7815 9.5368L17.4334 9.09711L18.7815 8.68648L19.2212 7.3093Z",
    fill: "url(#paint0_linear_620_138848)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_620_138848",
    x1: 0.547614,
    y1: 10.8769,
    x2: 21.009,
    y2: 10.8848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278846,
    stopColor: "#6ECCA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639423,
    stopColor: "#4285F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7054ED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_620_138848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicWand);
export default __webpack_public_path__ + "static/media/magic-wand.89f8f17c9b3f07976122a06350e3af5b.svg";
export { ForwardRef as ReactComponent };